"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-2 (https://dnwj8swjjbsbt.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class DataLocationResource {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DataLocationResource = DataLocationResource;
class ColumnWildcard {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ColumnWildcard = ColumnWildcard;
class DatabaseResource {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DatabaseResource = DatabaseResource;
class TableWildcard {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TableWildcard = TableWildcard;
class Resource {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Resource = Resource;
class DataLakePrincipal {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DataLakePrincipal = DataLakePrincipal;
class TableResource {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TableResource = TableResource;
class TableWithColumnsResource {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TableWithColumnsResource = TableWithColumnsResource;
class Permissions extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::LakeFormation::Permissions', properties);
    }
}
exports.default = Permissions;
Permissions.DataLocationResource = DataLocationResource;
Permissions.ColumnWildcard = ColumnWildcard;
Permissions.DatabaseResource = DatabaseResource;
Permissions.TableWildcard = TableWildcard;
Permissions.Resource = Resource;
Permissions.DataLakePrincipal = DataLakePrincipal;
Permissions.TableResource = TableResource;
Permissions.TableWithColumnsResource = TableWithColumnsResource;
